<template>
  <div>

    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex mb-5 bg-secondary rounded p-1 cursor-pointer gap-1">
        <div v-for="mode in modes" :key="'mode_'+mode.code" :class="{'bg-white': currentMode === mode.code, 'bg-hover-light-primary' : currentMode !== mode.code }" class="p-3 rounded" @click="setMode(mode.code)">
          <i :class="mode.icon+' fs-3'"></i>
        </div>
      </div>
      <div>
        <InputDate v-model="at" :show-time="true" :min="contractCreatedAt" @input="loadAssets()"/>
      </div>
    </div>
    <div class="d-flex gap-5">
      <div class="flex-3 form-control text-muted fw-bolder d-flex gap-2 align-items-center">
        <div class="d-flex align-items-center justify-content-center gap-3 text-uppercase">
          <div class="text-hover-primary cursor-pointer">
            Actifs
          </div>
          <div class="d-flex justify-content-center align-items-center mx-1">
            <i class="fad fa-angle-right"></i>
          </div>
        </div>
      </div>
      <div class="flex-2">
        <input class="form-control" placeholder="Rechercher" type="text" v-model="filter.content" @input="debounceSearch">
      </div>
    </div>
    <div class="d-flex border-1 border my-5 rounded border-gray-300">
      <div id="folder-container" ref="folderContainer" class="flex-3 flex-column d-flex position-relative p-5" @click="selectItem()">
        <div v-if="currentMode === 'LIST'" class="flex-1 d-flex flex-wrap gap-5 justify-content-start align-items-start">
          <AssetCard v-for="(item,uuid) in assetItems" :key="'card_'+uuid"
                     :item="item" :uuid="uuid" :selected="selectedUuid === uuid"
                     :item-types="itemTypes" :upload-root="uploadRoot" :resolve-photo="getItemPhoto"
                     @select="selectItem" @menu="showMenu"/>
        </div>
        <div v-else class="flex-1 d-flex flex-column gap-5">
          <div v-for="group in assetGroups" :key="'group_'+group.key">
            <div class="d-flex align-items-center gap-3 mb-3 pb-2 border-bottom">
              <div class="rounded-circle overflow-hidden d-flex align-items-center justify-content-center" style="width:36px;height:36px;background:#f5f5f5">
                <img v-if="group.photo" :src="group.photo" alt="" class="w-100 h-100 object-cover"/>
                <i v-else class="fad fa-user fs-4 text-muted"></i>
              </div>
              <div>
                <div class="text-muted fs-9 text-uppercase" style="letter-spacing:0.5px">{{ group.typeLabel }}</div>
                <div class="fw-bolder fs-6">{{ group.label }}</div>
              </div>
              <div class="ms-auto badge badge-light-primary">{{ group.items.length }} actif{{ group.items.length > 1 ? 's' : '' }}</div>
            </div>
            <div class="d-flex flex-wrap gap-5 ps-5">
              <AssetCard v-for="entry in group.items" :key="'tree_card_'+entry.uuid"
                         :item="entry.item" :uuid="entry.uuid" :selected="selectedUuid === entry.uuid"
                         :item-types="itemTypes" :upload-root="uploadRoot" :resolve-photo="getItemPhoto"
                         @select="selectItem" @menu="showMenu"/>
            </div>
          </div>
          <div v-if="assetGroups.length === 0" class="text-center text-muted py-5">
            Aucun actif à afficher
          </div>
        </div>
        <CustomPagination v-if="total > filter.perPage"
                          :currentPage="filter.page"
                          :itemsPerPage="filter.perPage"
                          :matchCount="matchCount"
                          :totalItems="total"
                          class="mb-5"
                          @update:currentPage="loadAssets"
        />


        <div v-if="menuVisible"
             ref="contextMenu"
             :style="{ top: menuY + 'px', left: menuX + 'px', zIndex: 9999, minWidth: '200px' }"
             class="position-absolute bg-white border border-gray-300 rounded shadow-lg py-2"
             @click.stop>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-primary" @click="handleMenuAction('open')">
            <i class="fad fa-folder-open me-2"></i>
            Ouvrir
          </div>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-primary" @click="handleMenuAction('edit')">
            <i class="fad fa-edit me-2"></i>
            Modifier
          </div>
          <div class="border-top border-gray-300 my-1"></div>
          <div class="menu-item px-4 py-2 cursor-pointer bg-hover-light-danger text-danger" @click="handleMenuAction('delete')">
            <i class="fad fa-trash me-2"></i>
            Supprimer
          </div>
        </div>

      </div>
      <div class="flex-2 d-flex  border-gray-300 overflow-auto" style="border-width:0;border-left-width: 1px;border-style: solid">

        <div v-if="selectedUuid" class="d-flex flex-column flex-1 overflow-auto">
          <div v-if="at" :class="items[selectedUuid]?.coverage && isCoverageValid(items[selectedUuid]?.coverage) ? 'bg-success text-inverse-success' : items[selectedUuid]?.coverage && !items[selectedUuid]?.coverage?.valid ? 'bg-warning text-inverse-warning' : 'bg-danger text-inverse-danger'" class="text-center rounded-top fw-bolder fs-2 py-2">
            {{ datify(at, 'dmY H:i') }}
            <div v-if="items[selectedUuid]?.coverage && isCoverageValid(items[selectedUuid]?.coverage)">
              L'actif est couvert
            </div>
            <div v-else>
              L'actif n'est pas couvert
            </div>
          </div>
          <div class=" d-flex  justify-content-center gap-10  p-5 ">
            <!--            <div v-if="hasRole('ROLE_ADMIN')" class="fw-bolder fs-5 text-muted">-->
            <!--              {{ selectedUuid }}-->
            <!--            </div>-->
            <div>
              <i :class="(itemTypes[items[selectedUuid]?.modelCode]?.icon || 'fad fa-cube')+' fs-5tx'"></i>
            </div>
            <div class="text-start d-flex flex-column justify-content-center gap-2">
              <div class="fw-bolder text-muted fs-2 gap-5 d-flex align-items-center text-uppercase">
                <div>
                  {{ items[selectedUuid]?.generatedAlias ??  items[selectedUuid]?.name }}
                </div>
                <i class="fad fa-edit text-muted fs-2 cursor-pointer"></i>
              </div>
              <div class="fw-bolder fs-2 gap-5 d-flex align-items-center">
                <div>
                  {{ items[selectedUuid]?.identifier }}
                </div>
                <div @click="updateAlias(selectedUuid)" class="cursor-pointer px-5">
                <i class="fad fa-sync fs-2 text-muted"></i>
                </div>
              </div>
            </div>
          </div>

            <div class="d-flex  bg-secondary rounded p-1 cursor-pointer gap-1 mx-5 my-2">
              <div v-for="sdt in selectDetailTabs" :key="'detail_tab_'+sdt.code" :class="{'bg-white': selectDetailTab === sdt.code, 'bg-hover-light-primary' : selectDetailTab !== sdt.code }"
                   class="p-3 rounded flex-grow-1 text-center fw-bolder text-uppercase"
                   @click="selectDetailTab = sdt.code">
                {{ sdt.label }}
              </div>
            </div>

          <div v-if="selectDetailTab === 'COVERAGE' && items[selectedUuid]?.coverage">
          <div v-if="items[selectedUuid]?.coverage?.insurer?.photo" class="d-flex justify-content-center py-2 ">
            <img :src="uploadRoot+items[selectedUuid]?.coverage?.insurer?.photo" alt="" class="w-150px rounded object-cover rounded-top" style="aspect-ratio: 3 / 1">
          </div>
          <div v-if="items[selectedUuid]?.coverage" :set=" coverage = items[selectedUuid]?.coverage">
            <div class="py-2 text-gray-400 text-center fw-bolder">
              {{items[selectedUuid]?.coverage?.insurer?.label}} ▪ {{ coverage.label }}
            </div>
            <div class="d-flex justify-content-center align-items-center gap-5 py-2">
              <div class="badge badge-light-success badge-lg">
                {{ datify(coverage?.startAt, 'dMY H:i:s') }}
              </div>
              <div>
                <i class="fad fa-arrows-left-right"></i>
              </div>
              <div v-if="coverage?.endAt" class="badge badge-light-danger badge-lg">
                {{ datify(coverage?.endAt, 'dMY H:i:s') }}
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center gap-5 py-2">
              <div class="badge badge-lg" :class="{
                'badge-light-warning' : coverage.status === 'PENDING',
                'badge-light-success' : coverage.status === 'ACTIVE',
                'badge-light-danger' : coverage.status === 'EXPIRED'
              }">
                {{coverage.status}}
              </div>
            </div>
            <div class="py-2 text-gray-400 text-center fw-bolder">
              <div v-if="coverage.avenant">
                <div v-if="avenantMap[coverage.avenant]" :set="avenant = avenantMap[coverage.avenant]">
              <span class="text-primary fw-bolder">
                AV{{ avenant.numero }}
              </span>
                  <span class="px-1">▪</span>
                  <span class="fw-bolder text-uppercase">
                  <template v-if="avenant.type">
                    {{ avenant.type }}
                  </template>
                  <template v-if="avenant.avenantType">
                    {{ avenant.avenantType.label }}
                  </template>
                </span>
                  <span class="px-1">▪</span>
                  <span class="text-primary fw-bolder">
                {{ avenant.police }}
                </span>
                </div>
                <div v-else>
                  {{ coverage.avenant }}
                </div>
              </div>
              <div>
              Crée le {{ datify(coverage?.createdAt, 'dMY H:i') }}
              </div>
            </div>

            <div >
               <div class="fs-2 fw-bolder text-uppercase px-5 border-top border-bottom py-2">
            Garanties
              </div>
              <div v-for="risk in coverage.risks" :title=" risk.isOptional ? 'Garantie Optionelle' : 'Inclus'" class="cursor-pointer py-1 px-2 d-flex gap-3 align-items-center mx-5">
                <i v-if="risk.isOptional" class="fad fa-shield-cross text-success "></i>
                <i v-else class="fad fa-shield-alt "></i>
                <div :class="{'text-success' : risk.isOptional}">
                  {{ risk.label }}
                </div>
                <div v-if="risk.isOptional" class="badge badge-light-success">{{ currency(risk.premium) }}</div>
              </div>
            </div>


            <div v-if="coverage.valid">
              <div v-if="!(coverage.printables && coverage.printables.length > 0)" class="p-5">
                <div class="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-0">
                  <div class="small">
                    <i class="fad fa-exclamation-triangle me-2"></i>
                    Aucun document n'a ete genere pour cette couverture
                  </div>
                  <button class="btn btn-sm btn-warning" :disabled="coverage.regenerating" @click="regenerateCoveragePrintables(coverage)">
                    <i v-if="!coverage.regenerating" class="fad fa-sync me-2"></i>
                    <i v-else class="fad fa-spinner fa-spin me-2"></i>
                    Générer les documents
                  </button>
                </div>
              </div>
              <div v-else class="d-flex  p-5 gap-5 justify-content-start align-items-center">
                <router-link v-for="printable in coverage.printables" :key="'coverage_'+coverage.uuid+'_printable_'+printable.slug"
                             :to="{name: 'coverage-printable-view',params: {printableSlug: printable.slug,coverageUuid: coverage.uuid}}" class="w-100px rounded py-2 px-2 d-flex flex-column justify-content-between
                            align-items-center bg-hover-light-primary border border-gray-300 position-relative"
                             target="_blank">
                  <div>
                    <i class="fad fa-file-pdf fs-3x"></i>
                  </div>
                  <div class="text-muted fs-8 fw-bolder my-2 text-center">
                    {{ printable.label }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          </div>
          <div v-if="selectDetailTab === 'COVERAGE' && !items[selectedUuid]?.coverage" class="p-5">
            <div v-if="!atIsToday" class="alert alert-light-info">
              <div class="d-flex align-items-start gap-3">
                <i class="fad fa-calendar-xmark fs-2 text-info"></i>
                <div>
                  <b>Pas de couverture à cette date</b>
                  <div class="mt-2">
                    Aucune couverture active pour <b>{{ datify(at, 'dMY') }}</b>.
                    Revenez à aujourd'hui pour voir la couverture actuelle s'il y en a une.
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="alert alert-warning">
              <div class="d-flex align-items-start gap-3">
                <i class="fad fa-triangle-exclamation fs-2 text-warning"></i>
                <div>
                  <b>Actif sous l'ancien format</b>
                  <div class="mt-2">
                    Cet actif utilise le modèle pré-v2 (<code>item_guarantees</code>) et n'a pas encore de couverture, de risks ni de printables générés.
                    Cliquez sur le bouton ci-dessous pour régénérer ces éléments depuis les données de l'item.
                  </div>
                </div>
              </div>
              <div v-if="isAdmin || isManager" class="mt-4">
                <button class="btn btn-primary" @click="convertSelectedItem">
                  <i class="fad fa-arrows-rotate me-1"></i>
                  Convertir cet actif
                </button>
              </div>
            </div>
          </div>

          <template v-if="selectDetailTab === 'BENEFICIARY'">
            <div v-if="selectedBeneficiary" class="p-5">
              <div class="d-flex align-items-center gap-4 mb-4">
                <div v-if="resolvePhotoFor(selectedBeneficiary)" class="rounded-circle overflow-hidden flex-shrink-0" style="width:72px;height:72px">
                  <img :src="resolvePhotoFor(selectedBeneficiary)" alt="" class="w-100 h-100 object-cover"/>
                </div>
                <div v-else class="rounded-circle bg-light d-flex align-items-center justify-content-center flex-shrink-0" style="width:72px;height:72px">
                  <i :class="(itemTypes[selectedBeneficiary.modelCode]?.icon || 'fad fa-user')+' fs-3x text-muted'"></i>
                </div>
                <div>
                  <div class="text-muted fs-8 text-uppercase">{{ itemTypes[selectedBeneficiary.modelCode]?.name || selectedBeneficiary.modelCode }}</div>
                  <div class="fw-bolder fs-3">{{ selectedBeneficiary.alias || selectedBeneficiary.generatedAlias || selectedBeneficiary.name }}</div>
                  <div v-if="selectedBeneficiary.identifier" class="text-muted fs-7">{{ selectedBeneficiary.identifier }}</div>
                </div>
              </div>
              <table class="table table-striped gx-5 mb-0">
                <tbody>
                  <tr v-for="row in beneficiaryDisplayProps(selectedBeneficiary)" :key="'ben_prop_'+row.code">
                    <td class="fw-bolder">{{ row.label }}</td>
                    <td class="text-end">{{ formattedValue(itemTypes[selectedBeneficiary.modelCode]?.properties?.[row.code], row.value) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="p-5">
              <div class="alert alert-light text-center">
                <i class="fad fa-user-slash fs-3 me-2"></i>
                Aucun bénéficiaire lié à cet actif
              </div>
            </div>
          </template>

          <template v-if="selectDetailTab === 'PROPERTIES'">
          <div class="d-flex align-items-center gap-5 py-2 text-dark px-2 border-top border-bottom cursor-pointer">
            <span class="fs-2 fw-bolder text-uppercase">
            Propriétés
              </span>
          </div>
          <div class="mh-400px">
            <table class="table table-striped gx-5">
              <tbody>
              <tr v-if="!items[selectedUuid]?.properties || Object.keys(items[selectedUuid].properties).length === 0">
                <td class="text-center text-muted py-5">Aucune propriété pour cet actif</td>
              </tr>
              <template v-for="(value,key) in (items[selectedUuid]?.properties || {})">
                <tr v-if="!itemTypes[items[selectedUuid]?.modelCode]?.properties?.[key]?.type?.code?.includes('OBJECT')" :key="'detail_prop_'+selectedUuid+'_'+key">
                  <td class="fw-bolder">
                    {{ itemTypes[items[selectedUuid]?.modelCode]?.properties?.[key]?.name || key }}
                  </td>
                  <td class="text-end">
                    <div v-if="value === null || typeof value !== 'object'">
                      {{ formattedValue(itemTypes[items[selectedUuid]?.modelCode]?.properties?.[key], value) }}
                    </div>
                    <div v-else-if="value && itemTypes[items[selectedUuid]?.modelCode]?.properties?.[key]">
                      {{ formattedValue(itemTypes[items[selectedUuid]?.modelCode]?.properties?.[key], value.value) }}
                      <div class="d-flex gap-2 align-items-center justify-content-end">
                        <div class="badge badge-light-success">
                          {{datify(value.validFrom,'dMy H:i')}}
                        </div>
                        <div>
                          <i class="fad fa-arrows-left-right"></i>
                        </div>
                        <div class="badge badge-light-danger">
                          {{datify(value.validTo,'dMy H:i')}}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      {{ typeof value === 'object' ? (value.value || JSON.stringify(value)) : value }}
                    </div>

                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
          </template>

          <template v-if="selectDetailTab === 'CALC_DETAILS' && items[selectedUuid]?.coverage">
            <div :set="cvg = items[selectedUuid].coverage">
              <div class="d-flex align-items-center gap-5 py-2 text-dark px-2 border-top border-bottom">
                <span class="fs-2 fw-bolder text-uppercase">
                  Détails de la couverture
                </span>
              </div>

              <template v-if="cvg.details && (Array.isArray(cvg.details) ? cvg.details.length > 0 : Object.keys(cvg.details).length > 0)">
                <table class="table table-striped gx-5 mb-0">
                  <thead>
                    <tr>
                      <th class="fw-bolder">Libellé</th>
                      <th class="fw-bolder text-end">Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, idx) in cvg.details" :key="'detail_'+idx">
                      <td>
                        <div>{{ detail.name || detail.code }}</div>
                        <div class="text-muted fs-8">{{ detail.code }}</div>
                      </td>
                      <td class="text-end fw-bolder">{{ currency(detail.value) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="isAdmin" class="text-end px-5 py-2">
                  <button class="btn btn-sm btn-light-warning"
                          @click="rebuildCoverageDetails(cvg.uuid)">
                    <i class="fad fa-sync me-1"></i>
                    Recalculer
                  </button>
                </div>
              </template>
              <div v-else class="text-center py-5">
                <div class="text-muted mb-3">Aucun détail enregistré</div>
                <button class="btn btn-sm btn-light-primary"
                        @click="rebuildCoverageDetails(cvg.uuid)">
                  <i class="fad fa-sync me-1"></i>
                  Recalculer les détails
                </button>
              </div>

              <div class="d-flex align-items-center gap-5 py-2 text-dark px-2 border-top border-bottom mt-3">
                <span class="fs-2 fw-bolder text-uppercase">
                  Premium Details
                </span>
              </div>

              <template v-if="cvg.premiumDetails && cvg.premiumDetails.length > 0">
                <table class="table table-striped gx-5 mb-0">
                  <thead>
                    <tr>
                      <th class="fw-bolder">Libellé</th>
                      <th class="fw-bolder text-end">Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pd, idx) in cvg.premiumDetails" :key="'pd_'+idx">
                      <td>
                        <div>{{ pd.label }}</div>
                        <div class="text-muted fs-8">{{ pd.methodCode || pd.code }}</div>
                      </td>
                      <td class="text-end fw-bolder">{{ currency(pd.premium) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-end px-5 py-3 border-top">
                  <span class="fw-bolder fs-4">
                    Total : {{ currency(cvg.premium) }}
                  </span>
                </div>
              </template>
              <div v-else class="text-muted text-center py-5">
                Aucun premium detail
              </div>
            </div>
          </template>
        </div>

      </div>
    </div>

  </div>
</template>


<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {helper} from "@/services/Helper";
import Property from "@/entity/Property";
import {api} from "@/services/Api";
import {auth} from "@/services/Auth";
import LoadingLogo from "@/components/LoadingLogo.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import Popup from "@/entity/Popup";
import InputDate from "@/components/InputDate.vue";
import PaymentTransaction from '@/entity/PaymentTransaction'
import Swal from 'sweetalert2'
import AssetCard from "@/components/ObjectNavigator/AssetCard.vue";

@Component({
  components: {InputDate, CustomPagination, LoadingLogo, AssetCard}
})
export default class AssetList extends Vue {
  @Prop({default: ''}) contractUuid?: string
  @Prop({default: () => []}) avenants!: any[];
  @Prop() currentDate?: any
  @Prop({default: null}) contractCreatedAt?: any
  @Prop({default: ''}) mode?: string
  filter = {content: '', page: 1, perPage: 50}
  coverageFilter = {page: 1, perPage: 10}
  modes = [
    {icon: 'fad fa-folder-tree', code: 'TREE'},
    {icon: 'fad fa-list-ul', code: 'LIST'},
  ]

  avenantMap = {}
  selectDetailTabs = [
    {icon: 'fad fa-folder-tree', label: 'Couverture', code: 'COVERAGE'},
    {icon: 'fad fa-user', label: 'Bénéficiaire', code: 'BENEFICIARY'},
    {icon: 'fad fa-list-ul', label: 'Propriétés', code: 'PROPERTIES'},
    {icon: 'fad fa-calculator', label: 'Détails calcul', code: 'CALC_DETAILS'},
  ]
  selectDetailTab = 'COVERAGE'
  showProperties = false
  searchTimeout: any = null
  uploadRoot = api.uploadRoot
  at = null
  items = {}
  currentMode = 'LIST'
  menuVisible = false
  menuX = 0
  menuY = 0
  selectedUuid = null
  total = 0
  matchCount = 0
  coverageTotal = 0
  coverageMatchCount = 0
  isLoading = false
  targetElement = null
  coverages = []
  currentCoverage = null
  loadItemWithProperties = true

  async regenerateCoveragePrintables(coverage: any) {
    this.$set(coverage, 'regenerating', true)
    try {
      const res = await api.post(api.core, `item/printable/coverage/${coverage.uuid}/regenerate`, {})
      if (res?.data?.status === 'success') {
        // Re-hydrater la collection sans recharger toute la page
        if (Array.isArray(res.data.printables)) {
          this.$set(coverage, 'printables', res.data.printables)
        }
        Swal.fire({icon: 'success', title: 'Documents générés', timer: 1500, showConfirmButton: false})
      } else {
        Swal.fire({icon: 'error', title: 'Échec de la génération', text: res?.data?.message || ''})
      }
    } catch (e) {
      Swal.fire({icon: 'error', title: 'Échec de la génération'})
    } finally {
      this.$set(coverage, 'regenerating', false)
    }
  }

  get itemTypes() {
    return this.$store.state.contractStore.itemTypes;
  }

  get atIsToday(): boolean {
    if (!this.at) return true
    const at = new Date(this.at)
    const now = new Date()
    return at.getFullYear() === now.getFullYear()
      && at.getMonth() === now.getMonth()
      && at.getDate() === now.getDate()
  }

  get assetItems(): Record<string, any> {
    const out: Record<string, any> = {}
    Object.entries(this.items || {}).forEach(([uuid, item]: [string, any]) => {
      if (item?.className === 'Asset') out[uuid] = item
    })
    return out
  }

  get assetGroups(): Array<{key: string; label: string; typeLabel: string; photo: string | null; items: Array<{uuid: string; item: any}>}> {
    const groups: Record<string, {key: string; label: string; typeLabel: string; photo: string | null; items: Array<{uuid: string; item: any}>}> = {}
    Object.entries(this.assetItems).forEach(([uuid, item]: [string, any]) => {
      const ben = this.findBeneficiary(item)
      const key = ben?.uuid || ben?.parentItem || '__orphan__'
      if (!groups[key]) {
        const benType = ben ? this.itemTypes?.[ben.modelCode] : null
        groups[key] = {
          key,
          label: ben ? (ben.alias || ben.generatedAlias || ben.name || benType?.name || '—') : 'Sans bénéficiaire',
          typeLabel: benType?.name || '',
          photo: ben ? this.resolvePhotoFor(ben) : null,
          items: [],
        }
      }
      groups[key].items.push({uuid, item})
    })
    return Object.values(groups)
  }

  resolvePhotoFor(item: any): string | null {
    if (!item?.properties) return null
    const it = this.itemTypes?.[item.modelCode]
    let propCode: string | null = null
    if (it?.properties) {
      const props: any = Array.isArray(it.properties) ? it.properties : Object.values(it.properties)
      const photoProp: any = props.find((p: any) => {
        const tCode = p?.type?.code || ''
        const tFormat = p?.type?.format || ''
        return tCode === 'PHOTO' || tCode === 'IMAGE' || tFormat === 'PHOTO' || tFormat === 'IMAGE'
          || p?.link === 'photo' || p?.code === 'photo'
      })
      if (photoProp) propCode = photoProp.code
    }
    if (!propCode && 'photo' in item.properties) propCode = 'photo'
    if (!propCode) return null
    const raw = item.properties[propCode]
    let value: any = raw
    if (raw && typeof raw === 'object' && 'value' in raw) value = raw.value
    if (Array.isArray(value)) value = value[0]
    if (helper.empty(value)) return null
    if (typeof value === 'string' && value.match(/^(https?:)?\/\//)) return value
    return this.uploadRoot + value
  }

  getItemPhoto(item: any): string | null {
    const own = this.resolvePhotoFor(item)
    if (own) return own
    const ben = this.findBeneficiary(item)
    if (ben) return this.resolvePhotoFor(ben)
    return null
  }

  findBeneficiary(item: any): any {
    if (!item) return null
    let current = item
    const visited = new Set<string>()
    let depth = 0
    while (current?.parentItem && !visited.has(current.parentItem) && depth < 8) {
      visited.add(current.parentItem)
      const parent = this.items[current.parentItem]
      if (!parent) break
      const className = parent.className || this.itemTypes?.[parent.modelCode]?.className
      if (className === 'Customer') return parent
      current = parent
      depth++
    }
    return null
  }

  get selectedBeneficiary(): any {
    if (!this.selectedUuid) return null
    return this.findBeneficiary(this.items[this.selectedUuid])
  }

  beneficiaryDisplayProps(ben: any): Array<{label: string; value: any; code: string}> {
    if (!ben?.properties) return []
    const it = this.itemTypes?.[ben.modelCode]
    const out: Array<{label: string; value: any; code: string}> = []
    Object.entries(ben.properties).forEach(([code, raw]: [string, any]) => {
      const pm = it?.properties?.[code]
      if (pm?.type?.code?.includes?.('OBJECT')) return
      if (pm?.internal) return
      let value = raw
      if (raw && typeof raw === 'object' && 'value' in raw) value = raw.value
      if (helper.empty(value)) return
      out.push({label: pm?.name || code, value, code})
    })
    return out
  }

  get isAdmin() {
    return auth.isAdmin();
  }

  get isManager() {
    return auth.hasRole('ROLE_MANAGER');
  }

  async convertSelectedItem() {
    if (!this.selectedUuid) return;
    const confirm = await Swal.fire({
      title: "Convertir cet actif ?",
      html: `<div class='text-start'>Cet actif va être convertit depuis son ancien modèle : ses <b>coverages</b>, <b>risks</b> et <b>printables</b> seront générés, ses propriétés consolidées en <b>property values</b>. Aucune fusion avec d'autres contrats.</div>`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Convertir",
      cancelButtonText: "Annuler",
    });
    if (!confirm.isConfirmed) return;
    this.isLoading = true;
    let res: any = null;
    let err: any = null;
    try {
      res = await api.post(api.core, "contract/item/convert/" + this.selectedUuid, {});
    } catch (e: any) {
      err = e;
    }
    this.isLoading = false;
    if (err) {
      await Swal.fire({icon: "error", title: "Échec", text: err?.response?.data?.message || err?.message || "Erreur"});
      return;
    }
    if (res?.data?.status === "success") {
      await Swal.fire({icon: "success", title: "Converti"});
      await this.loadAssets();
    } else {
      await Swal.fire({icon: "error", title: "Échec", text: res?.data?.message || "Erreur"});
    }
  }

  @Watch('currentDate')
  onDateChanged(val: string | null) {
    if (this.at !== val) {
      this.at = val
      this.loadAssets()
    }
  }

  @Watch('avenants')
  onAvenantsChanged(val: any) {
    this.avenantMap = {}
    if (Array.isArray(val)) {
      val.forEach((av: any) => {
        this.avenantMap[av.uuid] = av
      })
    }
  }

  isCoverageValid(coverage) {
    if (coverage) {
      const startAt = new Date(coverage.startAt)
      const endAt = coverage.endAt ? new Date(coverage.endAt) : null
      const at = new Date(this.at)
      return coverage.valid && startAt <= at && (!endAt || endAt >= at)
    }
    return false;
  }


  debounceSearch() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.filter.page = 1
      this.loadAssets()
    }, 500)
  }

  setMode(code) {
    this.currentMode = code
  }

  selectItem(uuid = null) {
    this.selectedUuid = uuid
    if (uuid) {
      this.coverageFilter.page = 1
      // this.loadCoverages()
    }
  }

  toggleCoverage(uuid) {
    if (this.currentCoverage === uuid) {
      this.currentCoverage = null
    } else {
      this.currentCoverage = uuid
    }
  }

  showMenu(e: MouseEvent, uuid: string) {
    e.preventDefault();
    this.selectedUuid = uuid;

    const container = this.$refs.folderContainer as HTMLElement;
    const containerRect = container.getBoundingClientRect();

    this.menuX = e.clientX - containerRect.left + 5;
    this.menuY = e.clientY - containerRect.top + 5;

    this.menuVisible = true;
  }

  hideMenu() {
    this.menuVisible = false;
    this.targetElement = null;
  }

  handleMenuAction(action: string) {
    this.menuVisible = false;
    if (!this.selectedUuid) return
    switch (action) {
      case 'open':
        this.selectItem(this.selectedUuid)
        break
      case 'edit':
        this.selectItem(this.selectedUuid)
        break
      case 'delete':
        this.$emit('delete', this.selectedUuid)
        break
    }
  }

  mounted() {
    this.onAvenantsChanged(this.avenants)
    if (this.currentDate) {
      this.at = this.currentDate
      this.loadAssets()
    } else if (this.currentDate === undefined) {
      this.loadAssets()
    }
    this.$nextTick(() => {
      if (this.$refs.folderContainer) {
        (this as any).$addListener(this.$refs.folderContainer, 'click', this.hideMenu);
        (this as any).$addListener(this.$refs.folderContainer, 'contextmenu', this.hideMenu);
      }
    });
  }

  formattedValue(model: any, value: any) {
    if (value === null || value === undefined) return '-'
    // Détection pack/objet complexe — prioritaire car value peut être string JSON ou objet
    const code = model?.type?.code
    const format = model?.type?.format
    if (code === 'PACK' || code === 'PACK_CATEGORY' || format === 'CLASS') {
      return this.extractLabel(value)
    }
    if (!model?.type) return !helper.empty(value) ? value : '-'
    try {
      if (format === 'DATE') {
        return helper.readable(new Date(value as any), ('dmY'))
      }
      if (code === 'AMOUNT' || code === 'NUMBER') {
        return helper.currencyFormat(value, false, false)
      }
      if (code === 'RADIO') {
        const choice = Object.values(model.choices || {}).find((c: any) => c.code === value) as any
        return choice?.label || value
      }
      if (code === 'BOOLEAN') {
        return value === true || value === 'true' ? 'Oui' : 'Non'
      }
    } catch (e) {
    }
    return !helper.empty(value) ? value : '-'
  }

  extractLabel(value: any): string {
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value
      if (typeof parsed !== 'object' || parsed === null) return parsed || '-'
      return parsed.label || parsed.name
          || parsed.pack?.label || parsed.pack?.name
          || parsed.category?.label || parsed.category?.name
          || JSON.stringify(parsed)
    } catch (e) {
      return value || '-'
    }
  }

  async updateAlias(uuid: string){
    const res = await api.get(api.core,'item/generate/alias/'+uuid)
    if (res?.data?.alias && this.items[uuid]) {
      this.$set(this.items[uuid], 'alias', res.data.alias)
      this.$set(this.items[uuid], 'generatedAlias', res.data.alias)
    }
  }
  generateAlias(uuid: any) {
    let generated = "";
    if (!this.items[uuid]) return

    generated = this.items[uuid].alias ?? this.items[uuid].name
    if (helper.empty(generated)) {
      const it = this.itemTypes[this.items[uuid].modelCode]
      if (!it) return
      Object.values(it.properties).forEach((pModel: any) => {
        if (pModel.isAlias && !pModel.type.code.match(/OBJECT/)) {
          if (!this.items[uuid]['properties']) {
            return
          }
          let value = this.items[uuid]['properties'][pModel.code];
          if (!helper.empty(value)) {
            generated += value
          }
        } else {

        }
      })
      if (helper.empty(generated.trim())) {
        generated = it.name
      }
      generated = generated.trim()
    }
    this.items[uuid].alias = generated
    return generated;
  }

  generateIdentifier(self: any) {
    let identifier = "";
    Object.values(self.properties).forEach((p: Property) => {
      if (p.model.identifier) {
        if (!helper.empty(p.value)) {
          if (!helper.empty(identifier)) {
            identifier += ' ';
          }
          identifier += p.value
        }
      }
    });
    identifier = identifier.trim()

    return identifier;
  }

  showPrintable(coverage, printable) {
    if (coverage.valid) {
      this.$router.push({
        name: 'coverage-printable-view',
        params: {printableUuid: printable.uuid, coverageUuid: coverage.uuid}
      })
      return
    }
    new Popup("Erreur", "Cette couverture est inactive.", "warning")
  }


  async loadAssets(page = null) {
    if (page && !isNaN(page)) {
      this.filter.page = page
    }
    this.isLoading = true
    const res = await api.post(api.core, `contract/assets/${this.contractUuid}`, {content: this.filter.content, page: this.filter.page, limit: this.filter.perPage, at: this.at});
    this.isLoading = false
    if (res?.data?.items) {
      this.total = res.data.total
      this.matchCount = res.data.total
      this.$set(this, 'items', res.data.items)
      Object.entries(res.data.items).forEach(([uuid, item]: [string, any]) => {
        if (item?.className !== 'Asset') return
        if (helper.empty(item.alias)) {
          this.generateAlias(uuid)
        }
        if (helper.empty(this.selectedUuid)) {
          this.selectedUuid = uuid
        }
      })
    }
  }

  async loadCoverages(page = null) {
    if (!this.selectedUuid) {
      return
    }
    if (page && !isNaN(page)) {
      this.coverageFilter.page = page
    }
    this.isLoading = true
    const res = await api.post(api.core, `contract/asset/data/${this.selectedUuid}`, {page: this.coverageFilter.page, limit: this.coverageFilter.perPage});
    this.isLoading = false
    // Les proprietes doivent etre chargees meme si l'actif n'a aucune couverture,
    // sinon le tab "Proprietes" reste vide. On les set independamment des coverages.
    if (res?.data) {
      if (this.items[this.selectedUuid] && res.data.properties) {
        this.$set(this.items[this.selectedUuid], 'properties', res.data.properties)
      }
      if (res.data.coverages) {
        this.coverageTotal = res.data.total
        this.coverageMatchCount = res.data.total
        this.$set(this, 'coverages', res.data.coverages)
      }
    }
  }

  coverageActivated(coverage: any) {
    return coverage.status === 'ACTIVE' || coverage.status === 'EXPIRED'
  }

  async rebuildCoverageDetails(coverageUuid: string) {
    this.isLoading = true
    const res = await api.get(api.core, `item/coverage/rebuild-details/${coverageUuid}`)
    this.isLoading = false
    if (res?.data?.status === 'success') {
      if (this.items[this.selectedUuid]?.coverage?.uuid === coverageUuid) {
        this.$set(this.items[this.selectedUuid].coverage, 'details', res.data.details)
        if (res.data.premiumDetails) {
          this.$set(this.items[this.selectedUuid].coverage, 'premiumDetails', res.data.premiumDetails)
        }
      }
    } else if (res?.data?.message) {
      alert(res.data.message)
    }
  }

}
</script>


<style scoped>
.tab-content, .tab-pane.active {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>